import { render, staticRenderFns } from "./AppointmentView.vue?vue&type=template&id=57830d64&scoped=true"
import script from "./AppointmentView.vue?vue&type=script&lang=js"
export * from "./AppointmentView.vue?vue&type=script&lang=js"
import style0 from "./AppointmentView.vue?vue&type=style&index=0&id=57830d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57830d64",
  null
  
)

export default component.exports